import * as React from "react"
import * as ReactDOM from "react-dom"
import { FormattedNumber, IntlProvider, addLocaleData } from "react-intl"
import { RentalAdvertPricing } from '../../../types/types'

import Price from './price'
import Error from './error'

type Props = {
  pricing: RentalAdvertPricing
  onPriceClick: () => void
}

type State = {
}

declare var window: { Gites: { locale: string }};


export default class Summary extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
    this.state = {
    }
  }

  render() {
    return (
      <div className="conversion-box__period">
        <div className="conversion-box--content">
          {this.props.pricing ?
            <Price
              onPriceClick={() => this.props.onPriceClick()}
              pricing={this.props.pricing}
            />
          : null}
        </div>
        <div className="conversion-box--btn">
        <div className="btn btn--primary" onClick={() => this.props.onPriceClick()}>
        {
          <span >{this.props.pricing ? this.props.pricing.bookLabel : null}</span>
        }
        </div>
        </div>
      </div>
    )
  }
}
